import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    loginLink: 'https://app.manycontent.com/login',
    registerLink: 'https://app.manycontent.com/register',
    resetPasswordLink: 'https://app.manycontent.com/reset-password'
  },
  mutations: {
    createAffiliateLinks (state, code) {
      const factory = url => `${url}?affiliate=${code}`

      state.loginLink = factory(state.loginLink)
      state.registerLink = factory(state.registerLink)
      state.resetPasswordLink = factory(state.resetPasswordLink)
    }
  }
})
